// extracted by mini-css-extract-plugin
export var black = "_18-6";
export var brand = "_18-1";
export var ddefault = "_18-0";
export var error = "_18-3";
export var gray = "_18-2";
export var highContrast = "_18-8";
export var outline = "_18-7";
export var success = "_18-5";
export var warning = "_18-4";